import { useQuery } from '@apollo/client';

import { DJ_REQUESTED_USERS } from '../graphql/query/djRequestedUsersQuery.graphql';

export const useDjRequestedUsersQuery = (eventId: string | null) => {
  return useQuery(DJ_REQUESTED_USERS, {
    variables: { eventId: eventId ?? '' },
    skip: !eventId,
  });
};
